











































import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

import AppLoadingBar from '@/components/app/AppLoadingBar.vue';
import AppSidebar from '@/components/app/AppSidebar.vue';
import AppHeader from '@/components/app/AppHeader.vue';
import ExporoLoading from '@/components/app/ExporoLoading.vue';
import Modal from '@/components/_common/Modal.vue';
import { centsToEuro } from '@/filters/currency';
import { Wallet } from '@/store/wallet/types';
import { BankAccount } from '@/store/mangoPay/types';
import { User } from '../store/profile/types';

@Component({
  components: {
    AppHeader,
    AppLoadingBar,
    ExporoLoading,
    AppSidebar,
    Modal,
  },
  filters: {
    centsToEuro,
  },
})
export default class App extends Vue {
  @Getter('appState/menuOpen') menuOpen?: boolean;
  @Getter('appState/isLoading') isLoading?: boolean;
  @Getter('profile/fullName') fullName?: string;
  @Getter('profile/exporoId') exporoId?: string;
  @Getter('profile/user') user?: User;

  @Getter('wallet/wallet') wallet?: Wallet;
  @Getter('mangoPay/bankAccounts') bankAccounts?: Array<BankAccount>;
  @Getter('mangoPay/loadingBankAccounts') loadingBankAccounts?: Boolean;

  @Action('appState/toggleMenu') toggleMenu: Function;
  @Action('profile/signOut') signOut: Function;

  get emoneyDisabled(): boolean {
    return process.env.VUE_APP_EMONEY_DISABLED === 'true';
  }

  get isLoadingUser(): Boolean {
    if (this.emoneyDisabled) return false;

    return !this.wallet;
  }

  get balance() {
    return this.$options.filters.centsToEuro(this.wallet?.Balance.Amount || 0);
  }
}
